import { Box, AspectRatio, Flex, Grid, Text } from '@chakra-ui/react'
import Image from 'next/image'
import Link from 'next/link'
import { COLOR } from './'

const Hero = () => {
  return (
    <Box className="px-4 lg:px-24 md:py-20 py-10">
      <div className="flex justify-between">
        <AspectRatio
          w={{
            base: '300px',
            sm: '400px',
            md: '354px',
            lg: '354px',
            xl: '354px'
          }}
          ratio={355 / 132}
          position="relative"
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/logo-1736414155291.png"
            alt="logo"
            fill
          />
        </AspectRatio>

        <div
          style={{
            aspectRatio: 381 / 101,
            width: '381px',
            position: 'relative'
          }}
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/description-1742442863380.png"
            alt="logo"
            fill
          />
        </div>
      </div>

      {/* Hero Main */}
      <AspectRatio w="100%" ratio={1260 / 601} position="relative">
        <div className="relative w-full h-full">
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/bg-hero-1742442863378.png"
            alt="bg hero"
            fill
          />

          <Link
            href="https://habbit.sg/products/zero2one-hair-tonic-by-ellixi-plus"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="absolute bottom-0 left-[10%] w-full">
              <AspectRatio
                w={{
                  base: '15%',
                  sm: '15%',
                  md: '15%',
                  lg: '15%',
                  xl: '15%'
                }}
                ratio={187 / 50}
                position="relative"
              >
                <Image
                  src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/yellow-buy-button-1736414155292.png"
                  alt="five tumbler"
                  fill
                />
              </AspectRatio>
            </div>
          </Link>
        </div>
      </AspectRatio>
      <Box className="w-full mx-auto md:pt-20 pt-10 px-4 md:px-8 xl:px-12">
        <Grid
          templateColumns={{ base: '1fr', lg: 'repeat(2, 1fr)' }}
          alignItems="center"
          className="gap-8 md:gap-x-8 xl:gap-x-16"
        >
          {/* Add Volume and Fullness */}
          <Flex className="xl:gap-8 gap-4 items-center">
            <Box
              borderColor={COLOR.YELLOW}
              color={COLOR.YELLOW}
              className="border-4 p-2 rounded-lg mb-2 text-center font-semibold whitespace-nowrap md:text-base text-sm md:w-40 w-32 flex-shrink-0 lg:px-2"
            >
              ADD VOLUME <br /> AND FULLNESS
            </Box>
            <Text color={COLOR.LIGHT} className="text-sm md:text-base">
              Boosts hair volume and thickness, enhancing texture for a fuller,
              bouncier appearance with natural lift.
            </Text>
          </Flex>

          {/* Repair Damaged Hair */}
          <Flex className="xl:gap-8 gap-4 items-center">
            <Box
              borderColor={COLOR.YELLOW}
              color={COLOR.YELLOW}
              className="border-4 p-2 rounded-lg mb-2 text-center font-semibold whitespace-nowrap md:text-base text-sm md:w-40 w-32 flex-shrink-0 lg:px-2"
            >
              REPAIR <br />
              DAMAGED HAIR
            </Box>
            <Text color={COLOR.LIGHT} className="text-sm md:text-base">
              Nourishes and repairs damaged hair, reduces split ends, and
              restores smoothness and vibrancy for healthier-looking hair.
            </Text>
          </Flex>

          {/* Strengthen Hair Roots */}
          <Flex className="xl:gap-8 gap-4 items-center">
            <Box
              borderColor={COLOR.YELLOW}
              color={COLOR.YELLOW}
              className="border-4 p-2 rounded-lg mb-2 text-center font-semibold whitespace-nowrap md:text-base text-sm md:w-40 w-32 flex-shrink-0 lg:px-2"
            >
              STRENGTHEN <br /> HAIR ROOTS
            </Box>
            <Text color={COLOR.LIGHT} className="text-sm md:text-base">
              Strengthens hair roots, reduces hair fall, and supports healthy,
              resilient hair growth from the roots.
            </Text>
          </Flex>

          {/* Anti-Dandruff and Itch Relief */}
          <Flex className="xl:gap-8 gap-4 items-center">
            <Box
              borderColor={COLOR.YELLOW}
              color={COLOR.YELLOW}
              className="border-4 p-2 rounded-lg mb-2 text-center font-semibold whitespace-nowrap md:text-base text-sm md:w-40 w-32 flex-shrink-0 lg:px-2"
            >
              ANTI-DANDRUFF <br /> AND ITCH RELIEF
            </Box>
            <Text color={COLOR.LIGHT} className="text-sm md:text-base">
              Eliminates dandruff and soothes itchiness, improving scalp health
              and providing a refreshing, comfortable feel.
            </Text>
          </Flex>
        </Grid>
      </Box>
    </Box>
  )
}

export default Hero
